var _g, _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoundLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 251,
    viewBox: "0 0 206 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dddd_1_328)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 103,
    cy: 81,
    r: 76,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.6277 93.0564C77.6598 92.9517 83.6034 79.5395 98.6083 70.5383C98.6083 70.5383 107.276 65.6143 112.3 64.6469C117.323 63.6777 116.026 71.5873 125.424 72.2334C133.781 72.8068 137.838 60.3069 138.946 56.3362C132.549 46.6125 121.518 40.1904 108.979 40.1904C89.203 40.1904 73.1719 56.1622 73.1719 75.8651C73.1719 82.0955 73.9006 86.9219 77.5939 93.0511C77.6117 93.0813 77.6277 93.0564 77.6277 93.0564Z",
    fill: "#EB4176"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3138 79.3252C74.6393 59.2655 91.3885 43.402 111.86 43.402C120.03 43.402 127.607 45.9297 133.849 50.243C127.406 44.0286 118.628 40.2034 108.952 40.2034C89.1775 40.2034 73.1445 56.1752 73.1445 75.8781C73.1445 77.0408 73.2051 78.191 73.3138 79.3252Z",
    fill: "#FC7CAA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M108.143 36.8194C116.441 36.6419 124.167 39.0417 130.572 43.2681C131.459 43.8538 132.615 43.8432 133.474 43.213L133.526 43.1775C135.026 42.0788 134.857 39.7819 133.201 38.9334C126.417 35.4544 118.724 33.4912 110.567 33.5C83.6486 33.5284 61.5421 55.2886 61.2071 82.1041C60.9523 102.306 72.9143 119.751 90.1944 127.575C95.0208 129.76 100.61 126.718 101.456 121.505C102.087 117.624 99.7992 113.895 96.0774 112.598C80.6216 107.212 69.5915 92.4402 69.8766 75.1389C70.2187 54.2875 87.2155 37.2631 108.143 36.8194Z",
    fill: "#9977CE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M141.229 60.2374C140.091 58.5759 139.782 60.4575 139.782 60.4575C139.782 60.4575 135.084 75.4708 125.039 74.6631C114.993 73.8555 116.452 66.4305 111.429 67.3997C106.405 68.3671 98.1437 73.8555 98.1437 73.8555C83.1388 82.8567 79.155 95.353 79.1212 95.4595C85.5315 105.103 96.5189 111.467 108.997 111.467C128.774 111.467 144.805 95.495 144.805 75.792C144.805 70.2166 143.52 64.9395 141.229 60.2374Z",
    fill: "#E1B54A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M144.644 72.3447C143.32 92.4062 126.571 108.27 106.1 108.27C97.9277 108.27 90.3504 105.742 84.1093 101.429C90.5535 107.641 99.3316 111.467 109.006 111.467C128.782 111.467 144.813 95.4948 144.813 75.7936C144.813 74.6292 144.754 73.4808 144.644 72.3447Z",
    fill: "#F4C969"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M101.023 123.11C100.832 120.831 99.2767 118.818 96.9873 118.167C78.4797 112.899 64.9303 95.9239 64.9303 75.7932C64.9303 67.2641 67.3658 59.3031 71.5758 52.5562C65.0764 60.8917 61.2031 71.3609 61.2031 82.7336C61.2031 102.694 73.1276 119.874 90.2634 127.603C94.5518 129.501 99.4193 127.291 101.023 123.11Z",
    fill: "#533984"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dddd_1_328",
    x: 0.488373,
    y: 0.581395,
    width: 205.023,
    height: 250.093,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.4186
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.4186
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_328"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 16.7907
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.39535
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1_328",
    result: "effect2_dropShadow_1_328"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 38
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.4884
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_1_328",
    result: "effect3_dropShadow_1_328"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 67.1628
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.2558
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_1_328",
    result: "effect4_dropShadow_1_328"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect4_dropShadow_1_328",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundLogo);
export default __webpack_public_path__ + "static/media/round-logo.2724c4a98a3c9fd8acf6ec76c8904c8e.svg";
export { ForwardRef as ReactComponent };